export function lazyLoadImages(lazyClass = 'lazy-img', lazyLoadedClass = 'lazy-img--loaded') {
  let lazyImages = [].slice.call(document.querySelectorAll('img.' + lazyClass))
  let active = false
  const lazyLoad = function () {
    if (active === false) {
      active = true
      setTimeout(function() {
        lazyImages.forEach(function(lazyImage) {
          if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== 'none') {
            lazyImage.src = lazyImage.dataset.src
            if (lazyImage.dataset.srcset) lazyImage.srcset = lazyImage.dataset.srcset
            lazyImage.classList.add(lazyLoadedClass)

            lazyImages = lazyImages.filter(function(image) {
              return image !== lazyImage
            });

            if (lazyImages.length === 0) {
              document.removeEventListener('scroll', lazyLoad)
              window.removeEventListener('resize', lazyLoad)
              window.removeEventListener('orientationchange', lazyLoad)
            }
          }
        });
        active = false
      }, 0)
    }
  };
  document.addEventListener('DOMContentLoaded', lazyLoad)
  document.addEventListener('scroll', lazyLoad)
  window.addEventListener('resize', lazyLoad)
  window.addEventListener('orientationchange', lazyLoad)
}

export function lazyLoadBackgroundImages (lazyBgClass = 'lazy-bg', lazyBgLoadedClass = 'lazy-bg--loaded') {
  // document.addEventListener('DOMContentLoaded', function() {
    const lazyBackgrounds = [].slice.call(document.querySelectorAll('.' + lazyBgClass))

    if ('IntersectionObserver' in window) {
      let lazyBackgroundObserver = new IntersectionObserver( function (entries, observer) {
        entries.forEach( function (entry) {
          if (entry.isIntersecting) {
            entry.target.style.backgroundImage = 'url(' + entry.target.dataset.bg + ')'
            entry.target.classList.add(lazyBgLoadedClass)
            lazyBackgroundObserver.unobserve(entry.target)
          }
        })
      })

      lazyBackgrounds.forEach( function (lazyBackground) {
        const backgroundImage = new Image()
        backgroundImage.src = lazyBackground.dataset.bg
        backgroundImage.onload = () => {
          lazyBackgroundObserver.observe(lazyBackground)
        }
      })
    }
  // })
}
